import SavedIndicator from './SavedIndicator';

export { SavedIndicator };
